<div id="main" class="report">
  <ng-container *ngIf="isLoading; else loaded">
    <div class="process-header">
      <h1>Proszę czekać</h1>
    </div>

    <div class="process-content">
      <div class="inner">
        <p>Pobieram dane...</p>
      </div>
    </div>
  </ng-container>

  <ng-template #loaded>
    <ng-container *ngIf="report; else unavailable">
      <div class="process-header">
        <h1>Sytuacja osoby zmarłej w publicznych bazach danych</h1>
      </div>

      <div class="process-content">
        <div class="inner">
          <div class="report">

            <section *ngIf="report.status !== 'PROCESSED'" class="report-header-box">
              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon-pending">update</span>
              </div>

              <div class="report-header-box__details">
                <h3 class="report-header-box__report-number">Raport w trakcie realizacji</h3>
                <p>Twój raport jest aktualnie generowany. Powiadomimy Cię, gdy będzie gotowy do pobrania.</p>

                <div class="progress">
                  <div class="progress__bar" [style.width.%]="progress"></div>
                </div>

                <div class="progress__footer">
                  <span>Trwa generowanie raportu...</span>
                  <span>{{ progress }}%</span>
                </div>
              </div>

              <div class="report-header-box__actions">
                <div class="report-header-box__report-status">
                  <strong>STATUS:</strong>
                  <span class="badge badge-warning u-margin-left-20">W REALIZACJI</span>
                </div>
              </div>

              <div class="report-header-box__report-notice">
                <span>Dane są pozyskiwane z publicznych baz danych.</span>
                <span> Nie zamykaj tej strony - powiadomimy Cię, gdy raport będzie gotowy.</span>
              </div>

            </section>

            <section  *ngIf="report.status !== 'PROCESSED' && reportDeleyed"  class="report-header-box report-header-box--info report-notice">
              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon">info</span>
              </div>
              <div class="report-header-box__details">
                <p>Realizacja Twojego raportu nadal trwa ze względu na czasowy brak odpowiedzi niektórych rejestrów rządowych. W rzadkich przypadkach czasowej niedostępności rejestrów, z których pobierane są dane tworzenie raportu może potrwać do 72 godzin, chociaż zwykle trwa to krócej.</p>
                <p>Twój raport jest nadal przygotowywany. Gdy tylko będzie gotowy otrzymasz od nas wiadomość e-mail z możliwością pobrania raportu w formacie PDF.</p>
              </div>

            </section>


            <section *ngIf="report.status === 'PROCESSED'" class="report-header-box">
              <div class="report-icon-wrapper">
                <span class="material-symbols-outlined report-icon">assignment</span>
              </div>
              <div class="report-header-box__details">
                <h3 class="report-header-box__report-number">{{ report.reportNumber }}</h3>
                <p class="report-header-box__desesed"><strong>Osoba zmarła: {{ report.deceased.name }} {{ report.deceased.lastName }}</strong></p>
                <p class="report-header-box__desesed"><strong>PESEL:</strong> {{ report.deceased.peselNumber }}</p>
                <p class="report-header-box__desesed"><strong>NIP:</strong> {{ report.deceased.taxId === 'XXXXXXXXXX'? '(nie podano)':report.deceased.taxId }}</p>
                <p class="report-header-box__death-date"><strong>Data zgonu:</strong> {{ report.deceased.dateOfDeath | date: 'longDate' }}</p>
              </div>

              <div class="report-header-box__actions">
                <button class="cta primary icon-button download-btn" (click)="generatePdf()">Pobierz raport <span
                  class="download-icon" aria-hidden="true"></span>
                </button>

                <div class="report-header-box__report-status">
                  <strong>STATUS:</strong>
                  <span
                    *ngIf="report.status === 'PROCESSED'"
                    class="badge badge-success u-margin-left-20">{{ report.status | reportStatus }}
            </span>
                  <span
                    *ngIf="report.status && report.status !== 'PROCESSED'"
                    class="badge badge-warning u-margin-left-20">{{ report.status | reportStatus }}
            </span>
                  <span
                    *ngIf="!report?.status"
                    class="badge badge-warning u-margin-left-20">{{ report.status | reportStatus }}
            </span>

                </div>

                <div><strong>Zamawiający:</strong> {{report.order.client.name}} {{report.order.client.lastName}} </div>

              </div>


              <div class="report-header-box__report-notice">
                <span>Wygenerowano na podstawie informacji z publicznych baz danych.</span>
                <span>Data wygenerowania informacji z baz danych: {{ report.databaseStatusOn | date:'d MMMM y, HH:mm:ss' }}</span>
              </div>

            </section>

            <section class="report-section">
              <div class="report-main-headers">
                <h3>Baza danych</h3>
                <h3>Wynik</h3>
              </div>

              <!-- CEIDG -->
              <article class="ceidg report-item">
                <header>
                  <div class="header-top">
                    <h3>Centralna Ewidencja Działalności Gospodarczej</h3>
                    <span class="result-header" [class.text-orange]="report.result.ceidg.status === 'PENDING'">
                  {{mapReportResult(report.result.ceidg.status)}}
                      <span class="result-header-skipped" *ngIf="report.result.ceidg.status === 'SKIPPED'">(nie podano NIP)</span>
                </span>


                  </div>
                  <p class="question-text">
                    Czy osoba zmarła prowadziła działalność gospodarczą?
                  </p>
                  <p class="description-text">
                    Prowadzenie działalności gospodarczej wiąże się z możliwością
                    występowania aktywów, ale również z możliwością występowania
                    zadłużenia w stosunku do administracji publicznej np. Zakładu
                    Ubezpieczeń Społecznych (ZUS), Urzędu Skarbowego lub
                    kontrahentów. Szczegóły w załączniku nr 1.
                  </p>
                </header>

                <div *ngIf="report.result.ceidg.status !== 'SKIPPED'" class="table-wrapper">
                  <table
                    class="alt db-result ceidg-table"
                    role="table"
                    aria-label="Dane CEIDG"
                  >
                    <thead>
                    <tr>
                      <th scope="col">NAZWA FIRMY</th>
                      <th scope="col">NIP</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">SPÓŁKA CYWILNA</th>
                    </tr>
                    </thead>

                    <tbody>
                    <ng-container *ngFor="let e of getCeidgRows(); let i = index">
                      <!-- wiersz główny -->
                      <tr>
                        <td class="company-name" data-label="NAZWA FIRMY">
                          {{ e.name }}
                        </td>
                        <td class="nip" data-label="NIP">
                          {{ e.taxId || "—" }}
                        </td>
                        <td class="status" data-label="STATUS">
                          {{ e.status | ceidgStatus | titlecase }}
                        </td>
                        <td class="civil-partnership" data-label="SPÓŁKA CYWILNA">
                          {{ getArrayLength(e.partnership) > 0 ? "Tak" : "Nie" }}
                        </td>
                      </tr>
                      <!-- wiersz dodatkowy z adresem -->
                      <tr class="address-row">
                        <td colspan="4">
                        <span class="label"
                        >Miejsce wykonywania działalności</span
                        >
                          <span class="value">{{
                              formatAddress(e.businessyAddress)
                            }}</span>
                        </td>
                      </tr>
                    </ng-container>

                    <tr *ngIf="getCeidgRows().length === 0">
                      <td colspan="4" class="empty-row">{{ getCeidgEmptyStateText() }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </article>

              <!-- KRS PR -->
              <article class="krs_pr report-item">
                <header>
                  <div class="header-top">
                    <h3>Krajowy Rejestr Sądowy</h3>
                    <span class="result-header" [class.text-orange]="report.result.krs.propertyRights.status === 'PENDING'">{{
                        mapReportResult(report.result.krs.propertyRights.status)
                      }}
                      <span class="result-header-skipped" *ngIf="report.result.krs.propertyRights.status === 'SKIPPED'">(nie podano NIP)</span>
                </span>
                  </div>
                  <p class="question-text">
                    Czy osoba zmarła posiadała prawa własności np. udziały lub akcje
                    w spółkach?*
                  </p>
                  <p class="description-text">
                    Posiadanie udziałów w spółkach jest aktywem, jednak jest to
                    uzależnione od kondycji danej spółki. Szczegóły w załączniku nr
                    2.
                  </p>
                </header>

                <div class="table-wrapper">
                  <table
                    class="alt db-result data-table"
                    role="table"
                    aria-label="Prawa własności w spółkach"
                  >
                    <thead>
                    <tr>
                      <th scope="col">NAZWA</th>
                      <th scope="col">FORMA PRAWNA</th>
                      <th scope="col">PRAWA WŁASNOŚCI</th>
                      <th scope="col">KRS</th>
                      <th scope="col">WPIS O ZALEGŁOŚCIACH</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of getKrsPropertyRightsRows()">
                      <td data-label="NAZWA">{{ item.name || "—" }}</td>
                      <td data-label="FORMA PRAWNA">
                        {{ mapLegalForm(item.legalForm) }}
                      </td>
                      <td data-label="PRAWA WŁASNOŚCI">
                        {{ getPropertyRightsText(item) }}
                      </td>
                      <td data-label="KRS">{{ item.ncrNumber || "—" }}</td>
                      <td data-label="WPIS O ZALEGŁOŚCIACH">
                        {{ mapDebtRecord(item.hasDebtRecord) }}
                      </td>
                    </tr>
                    <tr *ngIf="getKrsPropertyRightsRows().length === 0">
                      <td colspan="5" class="empty-row">
                        {{ getKrsPropertyRightsEmptyStateText() }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </article>

              <!-- KRS CA -->
              <article class="krs_ca report-item">
                <header>
                  <div class="header-top">
                    <h3>Krajowy Rejestr Sądowy</h3>
                    <span class="result-header" [class.text-orange]="report.result.krs.companyAuthorities.status === 'PENDING'">{{
                        mapReportResult(report.result.krs.companyAuthorities.status)
                      }}
                      <span class="result-header-skipped" *ngIf="report.result.krs.companyAuthorities.status === 'SKIPPED'">(nie podano NIP)</span>
                </span>
                  </div>
                  <p class="question-text">
                    Czy osoba zmarła pełniła funkcje we władzach spółki np. jako
                    członek zarządu spółki lub jej wspólnik?*
                  </p>
                  <p class="description-text">
                    Pełnienie niektórych funkcji w spółce może wiązać się z
                    odpowiedzialnością osobistą za zobowiązania spółki.
                  </p>
                </header>

                <div class="table-wrapper">
                  <table
                    class="alt db-result data-table"
                    role="table"
                    aria-label="Funkcje we władzach spółek"
                  >
                    <thead>
                    <tr>
                      <th scope="col">NAZWA</th>
                      <th scope="col">FORMA PRAWNA</th>
                      <th scope="col">KRS</th>
                      <th scope="col">FUNKCJA</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of getKrsCompanyAuthoritiesRows()">
                      <td data-label="NAZWA">{{ item.name || "—" }}</td>
                      <td data-label="FORMA PRAWNA">
                        {{ mapLegalForm(item.legalForm) }}
                      </td>
                      <td data-label="KRS">{{ item.ncrNumber || "—" }}</td>
                      <td data-label="FUNKCJA">
                        {{ item.companyAuthorities || "—" }}
                      </td>
                    </tr>
                    <tr *ngIf="getKrsCompanyAuthoritiesRows().length === 0">
                      <td colspan="4" class="empty-row">
                        {{ getKrsCompanyAuthoritiesEmptyStateText() }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </article>

              <!-- OTHER_DBS -->
              <article class="report-item" *ngFor="let row of getOtherDbsRows()">
                <header>
                  <div class="header-top">
                    <h3>{{ row.source }}</h3>
                    <span class="result-header" [class.text-orange]="row.status === 'PENDING'">{{
                        mapReportResult(row.status)
                      }}
                      <span class="result-header-skipped" *ngIf="row.status === 'SKIPPED'">(nie podano NIP)</span>
                </span>
                  </div>
                  <p class="question-text">{{ row.title }}</p>
                  <p class="description-text">{{ row.description }}</p>
                  <!-- Details if any -->
                  <div
                    class="details"
                    *ngIf="row.details"
                    style="margin-top: 10px; font-weight: bold"
                  >
                    {{ row.details }}
                  </div>
                </header>
              </article>

              <article class="report-note">
                <p class="report-notice">
                  *Prawa własności to np. udziały lub akcje. Jeżeli osoba zmarła
                  posiadała samodzielnie lub łącznie z innymi osobami mniej niż 10%
                  udziałów spółki z o.o. lub nie posiadała wszystkich akcji spółki
                  akcyjnej, informacje te mogą nie być publikowane w Dziale 1 KRS.
                </p>
              </article>
            </section>

          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #unavailable>
    <div class="process-header">
      <h1>Raport niedostępny</h1>
    </div>

    <div class="process-content">
      <div class="inner">
        <div class="report-expired">
          <h4>
            Ze względów bezpieczeństwa raport jest dostępny przez 72 godziny od momentu utworzenia.
            Jeśli ten czas minął, dostęp do raportu został automatycznie zakończony.
            Raport został usunięty z systemu.
            Aby sprawdzić aktualne dane osoby zmarłej, możesz zamówić nowy raport.
          </h4>

          <a
            class="cta cta--bold"
            [routerLink]="['/']"
            fragment="products"
            [ngxScrollTo]="'#products'"
            [ngxScrollToOffset]="-200"
          >
            Zamów nowy raport
          </a>
        </div>
      </div>
    </div>
  </ng-template>
</div>
